module.exports = __webpack_public_path__ + "img/search.a5f1ff91.svg";